import { DevelopmentalData, AgeGroup } from "@/types/developmental";
import { infantMilestones } from "./milestones/infant";
import { infantActivities } from "./activities/infant";
import { age1Milestones } from "./milestones/age1";
import { age1Activities } from "./activities/age1";
import { age2Milestones } from "./milestones/age2";
import { age2Activities } from "./activities/age2";
import { age3Milestones } from "./milestones/age3";
import { age3Activities } from "./activities/age3";
import { age4Milestones } from "./milestones/age4";
import { age4Activities } from "./activities/age4";
import { age5Milestones } from "./milestones/age5";
import { age5Activities } from "./activities/age5";
import { age6Milestones } from "./milestones/age6";
import { age6Activities } from "./activities/age6";

export const getMilestones = (age: AgeGroup): DevelopmentalData => {
  switch (age) {
    case 0:
      return infantMilestones;
    case 1:
      return age1Milestones;
    case 2:
      return age2Milestones;
    case 3:
      return age3Milestones;
    case 4:
      return age4Milestones;
    case 5:
      return age5Milestones;
    case 6:
      return age6Milestones;
    default:
      return {
        motor: [],
        language: [],
        cognitive: [],
        independent: [],
        social: [],
      };
  }
};

export const getActivities = (age: AgeGroup): DevelopmentalData => {
  switch (age) {
    case 0:
      return infantActivities;
    case 1:
      return age1Activities;
    case 2:
      return age2Activities;
    case 3:
      return age3Activities;
    case 4:
      return age4Activities;
    case 5:
      return age5Activities;
    case 6:
      return age6Activities;
    default:
      return {
        motor: [],
        language: [],
        cognitive: [],
        independent: [],
        social: [],
      };
  }
};